<template>
  <div class="hy-index">
    <van-sticky>
      <div class="index-nav">
        <router-link class="nav-link active" to="/">首页</router-link>
        <router-link class="nav-link" to="/meeting">会议</router-link>
        <router-link class="nav-link" to="/salon">沙龙</router-link>
        <router-link class="nav-link" to="/activity">活动</router-link>
      </div>
    </van-sticky>
    <div class="index-bannerbox">
      <van-swipe class="my-swipe" :autoplay="5000">
        <van-swipe-item v-for="(item, index) in imagesList" :key="index">
          <img v-lazy="item.imgUrl" @click="goPath(item.path)" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title">沙龙</h5>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell v-for="items in data" :key="items.id">
            <a class="more-link" @click="hy_more_click(3,'/index/conference/template?id='+items.id)">
              <div class="imgbox">
                <img :src="items.cover_url" alt />
                <span class="text_icon icon_yellow" v-if="items.status_str == '已发布' || items.status_str == '报名中'">{{items.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="items.status_str == '会议中'">{{items.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="items.status_str == '已结束' || items.status_str == '暂停报名' || items.status_str == '暂停报名'">{{items.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="items.status_str == '未到报名时间'">{{items.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="items.status_str == '报名截止'">{{items.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{items.status_str }}</span>
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{items.name}}</h5>
                  <span class="type">沙龙</span>
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe67f;</span>
                  {{items.start_time,'Y-M-D'|formatDates}}~{{items.end_time,'Y-M-D'|formatDates}}
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe64d;</span>
                  {{items.region}}&nbsp;{{items.specific_address}}
                </div>
              </div>
            </a>
          </van-cell>
        </van-list>
      </div>
    </div>
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <router-link class="nav-link iconfont" to="/">
          &#xe60e;
          <span class="text">会议平台首页</span>
        </router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
  </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDates } from "../assets/js/date"
export default {
  data() {
    return {
      imagesList: [
      ],
      searchValue: "",
      bannerdata:[],
      data: [],
      allList: [],
      loading: false,
      finished: false,
      footerNav: false,
      page: 0,
      pagesize: 5,
      total: 0
    };
  },
  created() {
    var _this =this;
   // this.list(_this.page,_this.pagesize);
    _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:''});
  },
  /* 时间过滤 */
  filters: {
    formatDates
  },
  methods: {
    hy_more_click(index,path){
      if(index == '5'){
        _trackData.push(['addaction', '会议服务', '沙龙列表页_MAP','滚动加载更多']);
      }
      if(index == '3'){
        _trackData.push(['addaction', '会议服务', '沙龙列表页_MAP','查看详情']);
        setTimeout(function(){
          window.location.href = path;
        },200)
      }
    },
    //banner跳转方法
    goPath(path) {
      if (path == "") {
        return false;
      }
      // this.$router.push(path);
      window.location.href = path;
    },
    //打开底部链接
    openFooterNav(val) {
      if (this.footerNav) {
        this.footerNav = false;
      } else {
        this.footerNav = true;
      }
    },

    //热门咨询加载
    onLoad() {
      setTimeout(() => {
        var _this = this;
        _this.page++;
        let url = "/ac1/conference/indexTab";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize,
          type: 2
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.allList = res.posts.data;
            _this.total = res.posts.count;
            _this.allList.forEach(v => {
              _this.data.push(v);
            });
            if(res.posts.banner.length != 0){
            _this.bannerdata =  res.posts.banner;
            _this.bannerdata.data.forEach(v => {
              _this.imagesList.push(
                {
                  imgUrl: v.pic_url,
                  path: v.url,
                  id:v.item_id
                }
              );
            });
            }
            // 加载状态结束
            _this.loading = false;
            // 数据全部加载完成
            if (_this.data.length >= _this.total) {
              _this.finished = true;
            }
            _this.hy_more_click(5);
          }
        });
      }, 500);
    },
    /*初始化列表 */
    list(page, pagesize) {
      var _this = this;
      let url = "/ac1/conference/indexTab";
      let params = {
        page: page,
        pagesize: pagesize,
        type: 2
      };
      _this.$get(url, params).then(res => {
        console.log(res);
        if (res.code == "2") {
          _this.data = res.posts.data;
          _this.images = res.posts.banner.data[0];
          _this.total = res.posts.count;
          if (_this.data.length >= _this.total) {
            _this.finished = true;
          }
          _this.bannerdata =  res.posts.banner;
          _this.bannerdata.data.forEach(v => {
            _this.imagesList.push(
              {
                imgUrl: v.pic_url,
                path: v.url,
                id:v.item_id
              }
            );
          });
        }
      });
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
</style>
